import React, { useRef, useCallback } from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

export function GraficoBarrasApiladas(props) {
  const { id, animation, labels, values, titulo, evaluados } = props;
  const divRef = useRef(null);
  const imgRef = useRef(null);

  const options = computeOptions(id, animation, titulo);
  const borderColorsL0 =     ['rgb(255, 0, 0)',           'rgb(255, 205, 86)',      'rgb(0, 128, 0)',];
  const backgroundColorsL0 = ['rgba(255, 0, 0, 0.2)',     'rgba(255, 255, 0, 0.4)', 'rgba(0, 128, 0, 0.6)'];
  const borderColorsL1     = ['rgb(128, 128, 128)',       'rgb(255, 0, 0)',         'rgb(255, 162, 0)',       'rgb(255, 205, 86)',      'rgb(0, 192, 0)',       'rgb(0, 128, 0)',];
  const backgroundColorsL1 = ['rgba(128, 128, 128, 0.2)', 'rgba(255, 0, 0, 0.2)',   'rgba(255, 162, 0, 0.2)', 'rgba(255, 255, 0, 0.4)', 'rgba(0, 192, 0, 0.4)', 'rgba(0, 128, 0, 0.6)'];
  const borderColorsL2 =     ['rgb(128, 128, 128)',       'rgb(255, 0, 0)',         'rgb(255, 40, 0)',        'rgb(255, 81, 0)',        'rgb(255, 162, 0)', 'rgb(255, 205, 162)', 'rgb(255, 205, 162)',       'rgb(255, 205, 86)',      'rgb(0, 96, 0)',        'rgb(0, 192, 0)', 'rgb(0, 128, 0)',];
  const backgroundColorsL2 = ['rgba(128, 128, 128, 0.2)', 'rgba(255, 145, 145, 1)', 'rgba(255, 145, 102, 1)', 'rgba(255, 172, 102, 1)', 'rgba(255, 206, 137, 1)', 'rgba(255, 227, 188, 1)', 'rgba(255, 255, 188, 1)', 'rgba(255, 255, 97, 1)', 'rgba(173, 255, 97, 1)', 'rgba(101, 204, 0, 1)', 'rgba(60, 158, 70, 1)']
  const data = {
    labels,
    datasets: generateData(values, evaluados)
  };

  const chartRef = useCallback(chart => {
    const div = divRef.current;
    let divStyle = "display: block";
    if (animation === undefined || animation) {
      if (div != null) {
        divStyle = "display: block";
      }
      
    }
    else { 
      
      const img = imgRef.current;

      var url = chart != null ? chart.toBase64Image() : "";

      if (img != null && url != null) {
        img.src = url;
      }

      divStyle = "display: none";
    }
    if (div != null) {
      div.style = divStyle;
    }
  }, []);

  function computeOptions(id, animation, titulo) {
    return {
      animation: animation,
      //onAnimationComplete: done(id, animation),
      indexAxis: 'y',
      elements: {
        bar: {
          borderWidth: 2,
        },
      },
      responsive: true,
      scales: {
        x: {
          stacked: true,
          max: 100,
        },
        y: {
          stacked: true
        }
      },
      plugins: {
        legend: {
          position: 'right',
        },
        title: {
          display: true,
          text: titulo,
        },
        datalabels: {
          display: function (context) {
            var index = context.dataIndex;
            var value = context.dataset.data[index];
            return value > 0;
          },
          formatter: function (value, context) {
            return value + '%';
          }
        }
      }
    };
  }

  function generateData(data, evaluados) {
    const etiquetas = [];
    data.forEach(p => {
      if (etiquetas.every(e => e.ordenAlternativa !== p.ordenAlternativa)) {
        etiquetas.push({ ordenAlternativa: p.ordenAlternativa, alternativa: p.alternativa });
      }
    });
    const totalEtiquetas = etiquetas.length;
    const datasets = etiquetas.map(e => {
      var borderColor;
      var backgroundColor;
      if (totalEtiquetas <= 3) {
        borderColor = borderColorsL0[e.ordenAlternativa - 1];
        backgroundColor = backgroundColorsL0[e.ordenAlternativa - 1];
      }
      else if (totalEtiquetas <= 6) {
        borderColor = borderColorsL1[e.ordenAlternativa - 1];
        backgroundColor = backgroundColorsL1[e.ordenAlternativa - 1];
      }
      else {
        borderColor = borderColorsL2[e.ordenAlternativa ];
        backgroundColor = backgroundColorsL2[e.ordenAlternativa ];
      }

      return {
        label: e.alternativa,
        data: data.filter(d => d.ordenAlternativa == e.ordenAlternativa).map(a => (a.frecuencia * 100 / evaluados).toFixed(0)),
        borderColor: backgroundColor, //borderColor,
        backgroundColor: backgroundColor
      }
    });
    return datasets;
  }

  return (<>
    <div ref={ divRef }>
      <Bar id={id} options={options} data={data} ref={chartRef} />
    </div>
    {animation !== undefined && !animation &&
      <img id={"img-" + id} ref={imgRef} src="" />
    }
    </>);
}